import { render, staticRenderFns } from "./StudentGridMobile.vue?vue&type=template&id=892644fc&scoped=true"
import script from "./StudentGridMobile.vue?vue&type=script&lang=js"
export * from "./StudentGridMobile.vue?vue&type=script&lang=js"
import style0 from "./StudentGridMobile.vue?vue&type=style&index=0&id=892644fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892644fc",
  null
  
)

export default component.exports